import ClientOAuth2 from "client-oauth2";

export default new class {

  clientId = '74c4f52e-69b1-4cf9-a757-4c2a739c9dce';
  clientSecret = 'MLVJ3g(%$Q~';
  accessTokenUri = 'https://itemizr.gravurapp.com/oauth/token';
  apiBaseUrl = 'https://itemizr.gravurapp.com';
  tokenUser = 'api_user_frontend_client';
  tokenPass = 'nC3S@!w5U&B';
  accessToken = false;

  authorize() {
    return new Promise((res, rej) => {
      let drupalAuth = new ClientOAuth2({
        clientId: this.clientId,
        clientSecret: this.clientSecret,
        accessTokenUri: this.accessTokenUri,
      });
      drupalAuth.owner
        .getToken(this.tokenUser, this.tokenPass)
        .then((user) => {
          this.accessToken = user.data.access_token;
          res(user);
        })
        .catch((error) => {
          rej(error)
        });
    })
  }

}
